import React from 'react';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const Header = () => {
  const username = localStorage.getItem('username');
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('username');
    navigate('/');
  };

  const pageTitle = () => {
    switch (location.pathname) {
      case '/news_highlights':
        return 'News Highlights';
      case '/news_dash':
        return 'All News';
      case '/add_news':
        return 'Ingest News';
      case '/archived_news':
        return 'Archive';
      default:
        return '';
    }
  };

  return (
      <header className="w-full p-4 flex justify-between items-center mb-6">
        <div className="ml-14">
          <h1 className="text-4xl font-roboto font-medium text-[#000] sm:text-2xl md:text-4xl">
            {pageTitle()}
          </h1>
        </div>

        <div className="ml-auto flex flex-row items-center space-x-4">
          <div>
            {username && (
              <button
                onClick={handleLogout}
                className="bg-[#fff] text-md text-gray-600 py-1 px-2 rounded hover:scale-105 duration-300"
              >
                <ExitToAppIcon />
              </button>
            )}
          </div>
        </div>
      </header>

  );
};
export default Header;
